import React from "react";
import { Col, Row } from "react-bootstrap";
import "../assets/styles/style.css";

export const Newsletter = ({ status, message, onValidated }) => {
  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp">
        <Row>
          <Col lg={12} md={6} xl={5} className="text-start text-md-start">
            <h3>Contact Me & Let's Connect</h3>
            <p>
              Reach out to me and let's connect! Whether you have a question, a
              project idea, or just want to say hello, I'm here to chat. Drop me
              a message and I'll get back to you as soon as possible. Looking
              forward to hearing from you!
            </p>
          </Col>
          <Col md={6} xl={7} className="text-start text-md-start">
            <h4>
              <i className="bi bi-envelope-fill"></i>&nbsp; Email Address
            </h4>
            <span>ushanmihiranga2017@gmail.com</span>
            <br />
            <br />
            <h4>
              <i className="bi bi-phone-fill"></i>&nbsp; Phone
            </h4>
            <span>+94760673035</span>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
